import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import "./AboutASG.css"; 
import "./PAS.css"

function MortalityTable() {
  const [, setInView] = useState(false);  
  const aboutasgSectionRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const debounce = (func, wait) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };

    const handleScroll = () => {
      if (aboutasgSectionRef.current) {
        const rect = aboutasgSectionRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setInView(true);
          timeoutRef.current = setTimeout(() => {
            if (aboutasgSectionRef.current) {
              aboutasgSectionRef.current.classList.add("done");
            }
          }, 2000);
        } else {
          setInView(false);
          if (aboutasgSectionRef.current) {
            aboutasgSectionRef.current.classList.remove("done");
          }
        }
      }
    };

    const debouncedHandleScroll = debounce(handleScroll, 100);

    window.addEventListener("scroll", debouncedHandleScroll);
    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [setInView]);  

  const handleDownloadASP = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to download the RFP-ASG Mortality Project.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const link = document.createElement("a");
        link.href = "/files/RFP-ASG Mortality Project.pdf"; 
        link.download = "RFP-ASG Mortality Project.pdf"; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };
  
  return (
    <div className="about-asg">
      <section className="section-aboutasg" ref={aboutasgSectionRef}>
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">MORTALITY TABLE</h2>
        <div className="sectionbottom-line"></div>
      </section>
      <div className="main-container">
          <section className="university-section">
            <div className="content">
              <h3>Request for Proposals (RFP) – Validation of the ASG Assured Life Mortality Table for Ghana</h3>

              <p>
                The Actuarial Society of Ghana (ASG) is pleased to invite your esteemed firm to 
                submit a proposal in response to our Request for Proposals (RFP) for the 
                Comprehensive Review and Technical Validation of the ASG Assured Life Mortality Table.
              </p>
              <p>
                As part of our strategic objective to promote actuarial excellence and enhance 
                life insurance pricing and reserving practices in Ghana, ASG has led a 
                multi-stakeholder effort — with support from the Ghana Insurers Association (GIA), 
                National Insurance Commission (NIC), United Nations Development Programme (UNDP), 
                Africa Re Foundation, and Milliman Inc. — to construct the country’s first 
                assured life mortality table under the UNDP-Milliman GAIN initiative.
              </p>
              <p>
                We are now seeking a qualified and experienced Actuarial Service Provider (ASP) to 
                independently validate the table through a structured review of its methodology, 
                assumptions, and technical robustness, as well as its suitability for adoption 
                across the insurance industry.
              </p>
              <p>
                Please find attached the full RFP document outlining the scope of work, deliverables, 
                submission requirements, evaluation criteria, and applicable timelines. Kindly take 
                note of the key deadline for proposal submission, which is <b>September 18, 2025</b>.
              </p>
              <p>
                We look forward to receiving your proposal and working together to deliver a rigorous 
                and globally benchmarked mortality reference for the Ghanaian insurance industry.
              </p>
              <p>
                Should you require any clarifications, do not hesitate to contact the ASG Mortality 
                Working Group via <a href="mailto:info@asg.org.gh">info@asg.org.gh</a>.
              </p>

            </div>
          </section>


        <section className="card-section" style={{ marginTop: "10px" }}>
            <div className="accreditation-card" onClick={handleDownloadASP} style={{ cursor: "pointer" }}>
                <h2 className="uni-title">RFP-ASG Mortality Project</h2>
            </div>
        </section>
      </div>
    </div>
  );
}

export default MortalityTable;
